import { render, staticRenderFns } from "./JudgePoomsaeTraditionalScreen.vue?vue&type=template&id=2e7ef4f4&scoped=true&"
import script from "./JudgePoomsaeTraditionalScreen.vue?vue&type=script&lang=js&"
export * from "./JudgePoomsaeTraditionalScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7ef4f4",
  null
  
)

export default component.exports